import { ThemeUIStyleObject } from 'theme-ui';

export const navigationMenuStyles: ThemeUIStyleObject = {
  display: 'flex',
  alignItems: 'center',
  marginLeft: '2rem',
  
  // Override ButtonGroup button styles
  button: {
    backgroundColor: 'transparent !important',
    fontSize: '1.125rem', // Larger font size (18px)
    fontWeight: 500,
    px: '1.5rem', // More horizontal spacing
    
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
    
    '&[data-selected="true"]': {
      backgroundColor: 'transparent !important',
      fontWeight: 600,
    },
  },
};
